import React from 'react'

import Tag from 'components/Tag'
import { useEventContext } from 'context/EventContext'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import useArticlesContext from '../../../../ArticlesProvider'

/** @type {import('./types').default}"} */
const TopicResult = ({ option }) => {
  const { fetchOnClick } = useArticlesContext()
  const { addEvent } = useEventContext()

  const textToRender = option.linkedFrom
    ? `${option.name} (${option.linkedFrom.labPostTestCollection.total})`
    : option.name

  return (
    <Tag
      className="TopicResult"
      variant="teal"
      {...(option?.linkedFrom?.labPostTestCollection?.total > 9
        ? {
            href: routeService.generatePath(ROUTE_NAMES.RESOURCES_TOPIC, { slug: option.slug }),
          }
        : { onClick: () => fetchOnClick(option.slug) })}
      {...addEvent({
        engagementComponent: 'search-engine',
        engagementDestination: 'go-to_topic_all-articles',
        engagementDetails: 'serp-item_topic',
        name: 'engagement_search',
      })}
    >
      {textToRender}
    </Tag>
  )
}

export default TopicResult
